import { Box, Flex } from "@chakra-ui/react";
import React from "react";
import { InfoToolTip } from "../../../../atoms/InfoToolTip";
import { EditableLedgerSection } from "./EditableLedgerSection";
import { LedgerTableHeaders } from "./LedgerTableHeaders";
import { SectionContainer, SectionTitle } from "./SectionTitle";
import { StaticLedgerSection } from "./StaticLedgerSection";
import { TransactionOverviewLedgerEntry } from "./TransactionOverviewLedgerEntry";

type TransactionLedgersSectionProps = {
  editMode: boolean;
  updating: boolean;
  ledgers: TransactionOverviewLedgerEntry[];
};

export const TransactionLedgersSection = React.memo(
  function TransactionLedgersSection({
    editMode,
    updating,
    ledgers,
  }: TransactionLedgersSectionProps): React.ReactElement {
    return (
      <Flex direction="column">
        <SectionContainer>
          <SectionTitle>Ledgers</SectionTitle>
          <InfoToolTip
            label="This transaction resulted in the following changes in balances. Each ledger has a classification which describes the reason why the balance changed."
            wrap
          />
        </SectionContainer>

        {/* the layout is not great on mobile currently, so wrap it in a horizontal scroll */}
        <Box w="full" overflowX="auto">
          <Box minW="50rem" w="full">
            <LedgerTableHeaders editMode={editMode} />

            {editMode ?
              <EditableLedgerSection ledgers={ledgers} updating={updating} />
            : <StaticLedgerSection ledgers={ledgers} />}
          </Box>
        </Box>
      </Flex>
    );
  },
);
